<script setup lang="ts">
type Props = {
    icon: string
    number?: number
}

const { number = 0, icon } = defineProps<Props>()
</script>

<template>
    <a class="w-10 h-10 flex border border-border rounded-full items-center justify-center relative transition-colors hover:bg-top-navbar hover:text-white">
        <i class="lni" :class="icon"></i>

        <span
            v-if="number > 0"
            class="absolute -top-2 -right-3 w-6 h-6 text-white bg-main rounded-full flex items-center justify-center text-xs"
        >
            {{ number }}
        </span>
    </a>
</template>
